import React, { useRef, CSSProperties } from 'react';

interface ISwipeListener {
    onSwipeLeft?(): void;
    onSwipeRight?(): void;
    onSwipeUp?(): void;
    onSwipeDown?(): void;
    minSwipeDistance?: number;
    children: React.ReactNode;
    className?: string;
    style?: CSSProperties;
}

function callIfFunction(fn: unknown) {
    if (typeof fn === 'function') fn();
}

const SwipeListener: React.FC<ISwipeListener> = ({
    onSwipeLeft,
    onSwipeRight,
    onSwipeUp,
    onSwipeDown,
    minSwipeDistance = 50,
    children,
    className,
    style
}) => {
    const touchStartX = useRef<number | null>(null);
    const touchStartY = useRef<number | null>(null);

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartX.current = e.touches[0].clientX;
        touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchEnd = (e: React.TouchEvent) => {
        if (touchStartX.current === null || touchStartY.current === null) return;

        const endTouch = e.changedTouches[0];
        const xDistance = endTouch.clientX - touchStartX.current;
        const yDistance = endTouch.clientY - touchStartY.current;

        const absXDistance = Math.abs(xDistance);
        const absYDistance = Math.abs(yDistance);

        if (absXDistance > absYDistance && absXDistance > minSwipeDistance) {
            if (xDistance > 0) callIfFunction(onSwipeLeft);
            else callIfFunction(onSwipeRight);
        } else if (absXDistance < absYDistance && absYDistance > minSwipeDistance) {
            if (yDistance > 0) callIfFunction(onSwipeUp);
            else callIfFunction(onSwipeDown);
        }

        touchStartX.current = null;
        touchStartY.current = null;
    };

    return (
        <div
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            className={className}
            style={{ width: '100%', height: '100%', ...style }}
        >
            {children}
        </div>
    );
};

export default SwipeListener;
